export default __webpack_public_path__ + "static/media/OPD_CARD_COVER.e8cb4ae9.png";